export default "__VITE_ASSET__CGSJKFpT__"